<!-- Loading bar -->
<fuse-loading-bar class="z-9999"></fuse-loading-bar>

<!-- Hidden icons to preload icon sets -->
<mat-icon svgIcon="mat_outline:home" class="hidden"></mat-icon>
<mat-icon svgIcon="heroicons_outline:home" class="hidden"></mat-icon>
<mat-icon svgIcon="feather:home" class="hidden"></mat-icon>
<mat-icon svgIcon="tb_illustrations:cookie" class="hidden"></mat-icon>

<!-- Install Overlay -->
@if (showInstallOverlay()) {
    <div
        *transloco="let t; prefix 'fidelity-app'"
        class="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50"
    >
        <div class="mx-4 max-w-md rounded-lg bg-white p-6 shadow-xl">
            <div class="mb-4 flex items-center justify-between">
                <h2 class="text-tb-primary font-semibold">{{ t('install-overlay.title') }}</h2>
            </div>
            <div class="mb-6">
                <p class="mb-4">{{ t('install-overlay.description') }}</p>
                <div class="rounded-lg bg-tb-primary/30 p-4">
                    <h3 class="mb-2 font-medium">{{ t('install-overlay.steps-title') }}</h3>
                    @if (isIOS()) {
                        <ol class="list-decimal space-y-2 pl-5">
                            <li>
                                {{ t('install-overlay.ios.step1') }}
                                <mat-icon class="text-default" svgIcon="mat_outline:ios_share"
                                          style="vertical-align: bottom"></mat-icon>
                            </li>
                            <li>{{ t('install-overlay.ios.step2') }}</li>
                            <li>{{ t('install-overlay.ios.step3') }}</li>
                            <li>{{ t('install-overlay.ios.step4') }}</li>
                        </ol>
                    } @else {
                        <ol class="list-decimal space-y-2 pl-5">
                            <li>
                                {{ t('install-overlay.step1') }}
                                <mat-icon class="text-default" svgIcon="mat_outline:more_vert"
                                          style="vertical-align: bottom"></mat-icon>
                            </li>
                            <li>{{ t('install-overlay.step2') }}</li>
                            <li>{{ t('install-overlay.step3') }}</li>
                        </ol>
                    }
                </div>
            </div>
            <div class="flex justify-end">
                <button mat-flat-button class="bg-tb-primary text-tb-primary-contrast" (click)="closeInstallOverlay()">
                    {{ t('install-overlay.got-it') }}
                </button>
            </div>
        </div>
    </div>
}

@if (!fidelityAppNav) {
    <generic-page-loading-state></generic-page-loading-state>
} @else {
    @if (!fidelityAppNavService.deviceIsMobile) {
        <fuse-vertical-navigation
            class="dark z-9999 bg-tb-app-nav text-tb-app-nav-contrast print:hidden"
            [mode]="'side'"
            [name]="'mainNavigation'"
            [navigation]="fidelityAppNav.default"
            [opened]="true"
        >
            <!-- Navigation header hook -->
            <ng-container fuseVerticalNavigationContentHeader>
                <!-- Logo -->
                <div class="vertical-navigation-image-container mb-6 flex h-40 items-center p-2">
                    @if (brandsService.logoUrl) {
                        <img
                            class="mx-auto my-auto h-auto max-h-full w-auto"
                            [src]="brandsService.logoUrl"
                            alt="Logo image"
                        />
                    }
                </div>
            </ng-container>
        </fuse-vertical-navigation>
    }
    <!-- Wrapper -->
    <div
        class="grid w-full justify-items-center text-base"
        [ngStyle]="{ height: layoutHeight() }"
        [style.grid-template-rows]="fidelityAppNavService.deviceIsMobile ? 'auto 1fr auto' : '1fr'"
        *transloco="let t; prefix: 'fidelity-app'"
    >
        <!-- Content -->
        @if (fidelityAppNavService.deviceIsMobile) {
            <div class="flex h-14 w-full flex-row-reverse items-center bg-tb-app-heading px-2 shadow-xl">
                <button mat-button matRipple (click)="openPage(availablePages['profile'])"
                        class="flex-row-reverse px-2">
                    <h3 class="mx-2 text-tb-app-heading-contrast">
                        {{ currentUser ? currentUser.firstName : t('login') }}
                    </h3>
                    <mat-icon
                        class="text-tb-app-heading-contrast icon-size-10"
                        svgIcon="heroicons_outline:user-circle"
                    ></mat-icon>
                </button>

                @if (showInstallBtn()) {
                    <button
                        mat-flat-button
                        class="ml-2 mr-auto bg-tb-primary text-tb-primary-contrast"
                        (click)="addToHomeScreen()"
                    >
                        <span>{{ t('install') }}</span>
                    </button>
                }
            </div>
        } @else {
            <button
                mat-button
                matRipple
                (click)="openPageDesktop(availablePages.profile)"
                class="absolute right-10 top-2 z-999 min-h-14 flex-row-reverse rounded-md bg-tb-app-heading text-tb-app-heading-contrast shadow-xl"
            >
                <h3 class="mx-2">{{ currentUser ? currentUser.firstName : t('login') }}</h3>
            </button>
        }
        <div [@routeAnimations]="prepareRoute(outlet)"
             class="router-outlet-wrapper w-full max-w-3xl overflow-auto xl:py-2">
            <router-outlet #outlet="outlet"></router-outlet>

            @for (entry of fidelityAppNavService.pagesHistory; track $index) {
                <div
                    class="fixed bottom-0 top-0 z-99 w-full"
                    [ngClass]="fidelityAppNavService.deviceIsMobile ? 'left-0 right-0' : 'max-w-3xl'"
                    [@slideInOut]
                >
                    <ng-container
                        *ngComponentOutlet="
                        entry.component;
                        inputs: entry.inputs;
                        injector: entry.injector;
                        content: entry.content
                    "
                    />
                </div>
            }
        </div>
        @if (fidelityAppNavService.deviceIsMobile) {
            <fuse-horizontal-navigation
                class="w-full bg-tb-app-nav px-2 pt-3 text-tb-app-nav-contrast"
                [name]="'appNavigation'"
                [navigation]="fidelityAppNav.compact"
            >
            </fuse-horizontal-navigation>
        }
    </div>
}
